module.exports = __webpack_public_path__ + "static/img/blur-close-up-code-computer-546819.5bf23194.jpg";